import {Injectable} from '@angular/core';
import {formatDate} from '@angular/common';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {Announcement} from '../models/announcement';
import {AnnouncementFilterCriteria} from '../models/filter/announcement-filter-criteria';
import {EmergencyAnnouncement} from '../models/emergency-announcement';

@Injectable()
export class AnnouncementService {

  constructor(private httpClient: HttpClient) {
  }

  getAnnouncementsNumber(announcementFilterCriteria: AnnouncementFilterCriteria): Observable<number> {
    return this.httpClient.post<number>(environment.baseUrlWs + '/api/announcements/filter/count', announcementFilterCriteria);
  }

  filterAnnouncements(announcementFilterCriteria: AnnouncementFilterCriteria, page?: number, userId = null):
    Observable<Announcement[]> {
    let url = '/api/announcements?pagination=true';
    if (page) {
      url += '&page=' + page;
    }
    if (userId) {
      url += '&createdByUser.id=' + userId;
    }
    if (announcementFilterCriteria.subject) {
      url += '&subject=' + announcementFilterCriteria.subject;
    }
    if (announcementFilterCriteria.message) {
      url += '&announcementSentMessage.message=' + announcementFilterCriteria.message;
    }
    if (announcementFilterCriteria.fromMail) {
      url += '&announcementSentMessage.fromMail=' + announcementFilterCriteria.fromMail;
    }
    if (announcementFilterCriteria.sentDateTo) {
      url += '&sentAt[strictly_before]=' + this.dayAfter(announcementFilterCriteria.sentDateTo);
    }
    if (announcementFilterCriteria.sentDateFrom) {
      url += '&sentAt[after]=' + announcementFilterCriteria.sentDateFrom;
    }
    if (announcementFilterCriteria.uuid && announcementFilterCriteria.uuid.length > 0) {
      const params = announcementFilterCriteria.uuid.reduce(
        (previous, message, index) => previous.append(`uuid[${index}]`, message.toString()),
        new HttpParams()
      );
      url += '&' + params.toString();
    }
    return this.httpClient.get<Announcement[]>(environment.baseUrlWs + url);
  }

  filterAnnouncementsClients(announcementFilterCriteria: AnnouncementFilterCriteria, page?: number):
    Observable<Announcement[]> {
    let url = '/api/announcements-client?pagination=true';
    if (page) {
      url += '&page=' + page;
    }
    if (announcementFilterCriteria.subject) {
      url += '&subject=' + announcementFilterCriteria.subject;
    }
    if (announcementFilterCriteria.message) {
      url += '&announcementSentMessage.message=' + announcementFilterCriteria.message;
    }
    if (announcementFilterCriteria.fromMail) {
      url += '&announcementSentMessage.fromMail=' + announcementFilterCriteria.fromMail;
    }
    if (announcementFilterCriteria.sentDateTo) {
      url += '&sentAt[strictly_before]=' + this.dayAfter(announcementFilterCriteria.sentDateTo);
    }
    if (announcementFilterCriteria.sentDateFrom) {
      url += '&sentAt[after]=' + announcementFilterCriteria.sentDateFrom;
    }
    if (announcementFilterCriteria.uuid && announcementFilterCriteria.uuid.length > 0) {
      const params = announcementFilterCriteria.uuid.reduce(
        (previous, message, index) => previous.append(`uuid[${index}]`, message.toString()),
        new HttpParams()
      );
      url += '&' + params.toString();
    }
    return this.httpClient.get<Announcement[]>(environment.baseUrlWs + url);
  }

  getAnnouncement(id: number): Observable<Announcement> {
    return this.httpClient.get<Announcement>(environment.baseUrlWs + '/api/announcements/' + id);
  }

  getLatestAnnouncements(): Observable<Announcement[]> {
    return this.httpClient.get<Announcement[]>(environment.baseUrlWs + '/api/announcements?pagination=true&itemsPerPage=3');
  }

  getLatestAnnouncementsClient(): Observable<Announcement[]> {
    return this.httpClient.get<Announcement[]>(environment.baseUrlWs + '/api/announcements-client?pagination=true&itemsPerPage=3');
  }

  sendNotificationToClients(emergencyAnnouncement: EmergencyAnnouncement) {
    return this.httpClient.post(environment.baseUrlWs + '/api/send-emergency-announcement' , emergencyAnnouncement);
  }

  private dayAfter(date: Date | string): string {
    const [month, day, year] = String(date).split('/').map(Number);
    return formatDate(new Date(year, month - 1, day + 1), 'MM/dd/yyyy', 'en-US');
  }
}
